import React from 'react';
import { Radio, Typography } from '../../../components';
import './RecoveryUI.scss';

const { Text } = Typography;

/**
 * Recovery UI component that matches _error_warning_recovery.hbs template
 * @param {string} componentId - ID of the preflight component
 * @param {string} checkId - ID of the preflight check
 * @param {Object} error - Error object with recovery information
 * @param {number} errorIndex - Index of the error in the errors array
 * @param {Function} onRecoveryChange - Callback when recovery choice changes
 * @param {Function} getRecoveryState - Function to get current recovery state
 */
export const RecoveryUI = ({ componentId, checkId, error, errorIndex, onRecoveryChange, getRecoveryState }) => {
    const currentRecovery = getRecoveryState(componentId, checkId, errorIndex);

    if (error.recovery === 'source_has_existing_migration_recovery') {
        return (
            <div key={`recovery-${componentId}-${checkId}-${errorIndex}`} className="recovery-ui override-recovery">
                <p className="recovery-question">Would you like to override the previous migration attempt?</p>
                <Radio.Group
                    className="recovery-radio-group"
                    onChange={(e) => onRecoveryChange(componentId, checkId, errorIndex, e.target.value)}
                    value={currentRecovery ? 'recover' : 'no'}
                >
                    <Radio value="recover">Yes</Radio>
                    <Radio value="no">No</Radio>
                </Radio.Group>
                <p className="recovery-help-text">
                    (For Stalled Migration Status, please look at a screenshot of the Target Worker to ensure the
                    migration is no longer running. If it is, please cancel this migration and wait for the previous
                    migration to complete)
                </p>
            </div>
        );
    } else if (error.recovery === 'source_has_previous_migration_attempt_recovery') {
        // This is typically auto-recovery, but we can show a message
        return (
            <div key={`recovery-${componentId}-${checkId}-${errorIndex}`} className="recovery-ui auto-recovery">
                <div className="auto-recovery-message">
                    <span className="checkmark">✓</span>
                    Auto-recovery applied for previous migration attempt
                </div>
            </div>
        );
    }

    return null;
};
